import BlockArticle from '@bridebook/web/app-basic/components/blocks/block-article';
import { toArticleCard } from '@bridebook/web/app-shared/lib/articles/to-article-card';
import { useTranslation } from 'next-i18next';
import { Box, Col, H4, Row } from '@bridebook/ui';
import { IArticle } from '@bridebook/web/app-shared/lib/articles/types';
import ArticleTilePlaceholder from '@bridebook/web/components/articles/placeholders/article-tile-placeholder';

interface IProps {
  articles?: IArticle[];
  articlesLoaded: boolean;
  expectedCount?: number;
  isBookmarksView?: boolean;
}

const List = ({ articles, articlesLoaded, expectedCount = 0, isBookmarksView }: IProps) => {
  const { t } = useTranslation('articles');

  const placeholdersCount = expectedCount - (articles?.length ? 7 : 0);
  return (
    <Box as="section">
      {articles?.length || !articlesLoaded ? (
        <>
          <Row gap={[0, 4]} data-name="articles-list">
            {articles?.map((result, index) =>
              index === 0 ? (
                <Col xs={12} key={result.ID}>
                  <BlockArticle firstArticle article={toArticleCard(result)} key={result.ID} />
                </Col>
              ) : (
                <Col xs={12} sm={6} md={6} lg={4} key={result.ID}>
                  <BlockArticle article={toArticleCard(result)} />
                </Col>
              ),
            )}
            {placeholdersCount > 0 &&
              [...Array(placeholdersCount).keys()].map((i) =>
                i === 0 ? (
                  <Col xs={12} key={i} maxH={500}>
                    <ArticleTilePlaceholder />
                  </Col>
                ) : (
                  <Col xs={12} sm={6} md={4} lg={4} key={i}>
                    <ArticleTilePlaceholder />
                  </Col>
                ),
              )}
          </Row>
        </>
      ) : (
        <Box my={10} alignItems="center">
          <H4>{isBookmarksView ? t('noBookmarkedYet') : t('articlesNotFound')}</H4>
        </Box>
      )}
    </Box>
  );
};

export default List;
